<script lang="ts">
  import Game from '$components/blocks/game/game.svelte';
  import Seo from '$components/seo.svelte';
  import type { GamePage } from './content';
  import bgLeft from './assets/bg-left.png';
  import bgRight from './assets/bg-right.png';
  import { navbarInfo } from '$components/navigation/navbar.svelte';

  export let data: GamePage;

  // const inputName = 'group';
  // const groupNames = derived(lang, () => [
  //   get(t)('faq.default'),
  //   ...data.story.content.groups.map((grp) => grp.name)
  // ]);

  // let group = $page.url.searchParams.get(inputName) || $groupNames[0];

  // $: if (!$groupNames.includes(group)) {
  //   group = $groupNames[0];
  // }
</script>

<Seo
  title={data.story.content.seo_title}
  description={data.story.content.seo_description}
  image={data.story.content.seo_og_image}
/>

<!-- TODO: Try to apply all background properties via Tailwind instead of plain CSS-->
<!-- Try to use h-[calc(100dvh-{$navbarInfo?.rect.height || '0'}px)] -->
<section
  class="h-[calc(100dvh-var(--header-height))] relative"
  style="background: radial-gradient(197.94% 100% at 50% 0%, #D4E0ED 28.24%, #B6CCE2 100%); --header-height: {$navbarInfo
    ?.rect.height || 0}px"
  role="none"
  on:click={(event) =>
    event.currentTarget?.scrollIntoView({
      block: 'end',
      inline: 'nearest',
      behavior: 'smooth'
    })}
>
  <div class="absolute top-0 h-full w-full flex justify-between items-stretch">
    <div
      style="--image-url: url({bgLeft})"
      class="w-[30vh] bg-no-repeat bg-[image:var(--image-url)] bg-left bg-cover"
    ></div>
    <div
      style="--image-url: url({bgRight})"
      class="w-[30vh] bg-no-repeat bg-[image:var(--image-url)] bg-right-bottom bg-cover"
    ></div>
  </div>

  <div class="h-[calc(100dvh-4rem)] w-full py-4 flex items-center justify-center">
    <Game gameStory={data.story} />
  </div>
</section>
